import clsx from 'clsx';
import { destroyCookie } from 'nookies';

import Grid from 'components/Grid';
import ListingSkeleton from 'components/ListingSkeleton';
import Pagination from 'components/Pagination';
import Typography from 'components/Typography';
import { useAppContext } from 'context/AppContext';
import { usePreload } from 'context/PreloadContext';
import { STATUS } from 'helpers/spa';
import ListingCard from 'screens/serp/components/ListingCard';

import Filters from '../Filters';

import classes from './FilteredListings.module.scss';

/** @type {import("./types").default} */
const FilteredListings = ({
  className,
  listings,
  pagination,
  facets,
  category,
  hasDemoForm,
  onShowPricingModal,
}) => {
  const { head } = useAppContext();
  const { status } = usePreload();

  const clearCallback = () => {
    destroyCookie(null, `per_${head.category.slug}`, { path: '/' });
  };

  const title = `Other ${head.page_header}`.replace(/- Page \d+/, '');
  return (
    <Grid className={clsx('FilteredListings', classes.root, className)}>
      <Typography
        component={'h2'}
        className={classes.title}
        id="full-list-of-products"
      >
        {title}
      </Typography>
      <Filters
        clearCallback={clearCallback}
        facets={facets}
        rootUrl={category.cta_urls.detail}
      />

      {status === STATUS.idle &&
        listings.map((listing, index) => {
          const onShowPricingModalWithId = () =>
            onShowPricingModal({ pGuid: listing.global_product_id });
          return (
            <ListingCard
              key={listing.name}
              listing={listing}
              onShowPricingModal={onShowPricingModalWithId}
              hasDemoForm={hasDemoForm}
              listingPosition={index}
            />
          );
        })}
      {status === STATUS.loading && (
        <div>
          {[...Array(listings.length)].map((_, i) => (
            <ListingSkeleton
              // eslint-disable-next-line react/no-array-index-key
              key={`listing-skeleton-${i}`}
            />
          ))}
        </div>
      )}
      {status === STATUS.error && <h1>error</h1>}
      {pagination.num_pages > 1 && (
        <Pagination className={classes.pagination} pagination={pagination} />
      )}
    </Grid>
  );
};
export default FilteredListings;
